import { render, staticRenderFns } from "./DiagnoseModel.vue?vue&type=template&id=6490f042&scoped=true&"
import script from "./DiagnoseModel.vue?vue&type=script&lang=js&"
export * from "./DiagnoseModel.vue?vue&type=script&lang=js&"
import style0 from "./DiagnoseModel.vue?vue&type=style&index=0&id=6490f042&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6490f042",
  null
  
)

export default component.exports